import { render, staticRenderFns } from "./WedCollectionDetail.vue?vue&type=template&id=2b37ec77&scoped=true"
import script from "./WedCollectionDetail.vue?vue&type=script&lang=js"
export * from "./WedCollectionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b37ec77",
  null
  
)

export default component.exports